import { useState, useCallback, useEffect } from 'react';
import { SearchIcon } from '../icons';
import { haptic } from '../../utils/haptic';

const DEBOUNCE_MS = 400;

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function SearchBar({ value, onChange, placeholder = 'Поиск проектов...' }: SearchBarProps) {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    if (localValue === value) return;
    const t = window.setTimeout(() => {
      onChange(localValue);
    }, DEBOUNCE_MS);
    return () => window.clearTimeout(t);
  }, [localValue, value, onChange]);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalValue(e.target.value);
  }, []);

  const handleClear = useCallback(() => {
    setLocalValue('');
    onChange('');
    haptic.tap();
  }, [onChange]);

  return (
    <div className="showcase-search">
      <span className="showcase-search__icon" aria-hidden>
        <SearchIcon size={16} />
      </span>
      <input
        type="search"
        className="showcase-search__input"
        value={localValue}
        onChange={handleChange}
        placeholder={placeholder}
        autoComplete="off"
        aria-label="Поиск"
      />
      {localValue ? (
        <button
          type="button"
          className="showcase-search__clear"
          onClick={handleClear}
          aria-label="Очистить поиск"
          style={{
            background: 'none',
            border: 'none',
            padding: 4,
            marginLeft: 4,
            color: 'rgba(255,255,255,0.5)',
            cursor: 'pointer',
            fontSize: 18,
            lineHeight: 1,
          }}
        >
          ×
        </button>
      ) : null}
    </div>
  );
}
